import CurrentProvider from '../../../providers/CurrentProvider'
import RequestProvider from '../../../providers/RequestProvider'
import CandidatosDataProvider from './CandidatosDataProvider'
import LiveDataProvider from './LiveDataProvider'

const Providers2023 = (props: object) => (
  <RequestProvider
    api={{
      id: '2023_consejeros',
      url: process.env.NEXT_PUBLIC_API_URL_2023 || '',
    }}
  >
    <RequestProvider
      api={{
        id: 'mapas',
        url: process.env.NEXT_PUBLIC_API_URL_MAPAS || '',
      }}
    >
      <CurrentProvider
        apiId="2023_consejeros"
        currentKey="previa"
        currentPath="/Constituyentes2023/Previa/_current.json"
        oneTime
      >
        <CurrentProvider
          apiId="2023_consejeros"
          currentKey="live"
          currentPath="/Constituyentes2023/Live/_current.json"
          oneTime
        >
          <LiveDataProvider {...props}>
            <CandidatosDataProvider {...props} />
          </LiveDataProvider>
        </CurrentProvider>
      </CurrentProvider>
    </RequestProvider>
  </RequestProvider>
)

export default Providers2023
